module.exports = __webpack_public_path__ + "static/media/logo@2x.4e076e03.webp";